<template>
  <template v-if="typeContextCourant === TypesContextesAutorisesEnum.Prestataire">
    <BasicText>
      En tant que prestataire vous pouvez pré-saisir une demande de formation et la soumettre à l’employeur pour
      validation.
    </BasicText>
    <BasicText>
      Pour votre information, l'adresse e-mail de l'employeur est indispensable lors de la saisie de la demande. Elle
      permettra l'envoi d'un e-mail informant l'employeur de la pré-saisie de la demande de formation. Celui-ci pourra
      ainsi vérifier l'exactitude des données saisies et aura la possibilité d'accepter ou de refuser la demande.
    </BasicText>
    <BasicText>
      Si la demande est acceptée et transmise à AKTO, vous recevrez une notification d’accord. En revanche, si
      l'employeur refuse de reprendre la demande, vous en serez informé.
    </BasicText>
    <BasicText>Pour vous aider dans la saisie de la demande, vous trouverez ci-dessous des liens utiles.</BasicText>
    <BasicText>
      <ul>
        <li
          v-for="(urlLabel, i) in urlLabelsPrestataire"
          :key="i"
        >
          <BasicLink
            :label="urlLabel.label"
            @link-click="redirectExterne(urlLabel.url)"
          />
        </li>
      </ul>
    </BasicText>
  </template>
  <template v-else>
    <BasicText>
      Le dispositif de Reconversion ou promotion par l’alternance, dit
      <BasicText weight="bold">Pro-A</BasicText>
      , est un parcours de formation individualisé réalisé en alternance, afin de permettre à un salarié en poste de
      changer de métier ou bénéficier d’une promotion sociale ou professionnelle, en accord avec son employeur.
    </BasicText>
    <BasicText>
      Avant de conclure une
      <BasicText weight="bold">Pro-A</BasicText>
      , renseignez-vous sur les règles applicables ainsi que les dispositions particulières prévues par votre convention
      collective ou les accords collectifs de branche (Exemple : certification éligible, la durée maximale ou bien le
      montant du forfait de formation). N’hésitez pas à vous rapprocher de votre conseiller.
    </BasicText>
    <BasicText>
      Pour vous aider dans la compréhension du dispositif et la saisie de la demande, vous trouverez ci-dessous des
      liens utiles.
    </BasicText>
    <BasicText>
      <ul>
        <li
          v-for="(urlLabel, i) in urlLabels"
          :key="i"
        >
          <BasicLink
            :label="urlLabel.label"
            @link-click="redirectExterne(urlLabel.url)"
          />
        </li>
      </ul>
    </BasicText>
  </template>

  <WrapperCheckbox
    v-model="validationNotice"
    :alertLabel="meta.validationNotice?.$messageErreurDirty!"
    :readonly
  >
    <BasicText>
      J'ai pris connaissance de la
      <BasicLink
        label="notice"
        @link-click="redirectExterne('https://www.formulaires.service-public.fr/gf/cerfa_16155.do')"
      />
      comprenant les informations liées au traitement des données à caractère personnel dans le cadre.
    </BasicText>
  </WrapperCheckbox>
</template>

<script setup lang="ts">
  import { TypesContextesAutorisesEnum } from '@/features/auth/context-app'
import type { UrlLabel } from '@/features/interface/shared/tools'
import { redirectExterne } from '@/features/shared/tools/url'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'
import { useDemandePROAStore } from '../../useDemandePROAStore'

  const store = useDemandePROAStore()
  const { setupFieldWithKey } = store
  const { meta, readonly, typeContextCourant } = storeToRefs(store)

  const validationNotice = setupFieldWithKey<boolean>('validationNotice')

  const urlLabels = computed(() => {
    const urlsLabels: UrlLabel[] = []
    urlsLabels.push({
      label: 'Les règles de prise en charge',
      url: 'https://www.akto.fr/financer-une-formation/regles-de-prise-en-charge/',
    })
    urlsLabels.push({
      label: 'Pro-A site AKTO',
      url: 'https://www.akto.fr/pro-a-salarie/',
    })
    urlsLabels.push({
      label: 'Pro-A site service public',
      url: 'https://www.service-public.fr/particuliers/vosdroits/F13516',
    })

    urlsLabels.push({
      label: 'Tuteur et critères d’éligibilité',
      url: 'https://www.akto.fr/recruter-en-alternance/le-tutorat/',
    })

    urlsLabels.push({ label: 'Le mode opératoire', url: 'https://ressourcesstatiques.akto.fr/guide/v2/GuideProA.pdf' })
    return urlsLabels
  })

  const urlLabelsPrestataire = computed(() => {
    const urlsLabels: UrlLabel[] = []

    urlsLabels.push({
      label: 'Le mode opératoire',
      url: 'https://ressourcesstatiques.akto.fr/guide/v2/GuideProAPrestataire.pdf',
    })
    return urlsLabels
  })
</script>
